import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const SummariesContext = createContext();
const { initialFilter } = UIHelpers();

export function useSummariesContext () {
    return useContext(SummariesContext);
}

export const SummariesUIConsumer = SummariesContext.Transaction;

export function SummariesProvider ({ transactionsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const collection = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        collection
    };

    return <SummariesContext.Provider value={value}>{children}</SummariesContext.Provider>;
}
